var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ontologies.length)?_c('div',{staticClass:"ontologies"},[_c('b-form-select',{attrs:{"options":_vm.ontologiesOption},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }